<template>
    <div class="legenda-destacada mb-2">
        <div>
            <v-icon size="20px"
                    class="mr-3">
                fas fa-exclamation-circle
            </v-icon>
        </div>

        <div>
            <p class="mensagem-aviso">
                Sr. Fornecedor, a(s) linha(s) de fornecimento do(s) item(ns) a seguir não foi(foram) encontrada(s) em seu cadastro, por favor,
                atualize seu cadastro e retorne para o lançamento de proposta.
            </p>
            <p v-for="(item, index) in itens" :key="index">
                {{item.linhaFornecimentoMensagem}}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LinhaFornecimentoMsgAlert',
    props: {
        itens:{
            type: [],
            default: []
        },
    }
}
</script>

<style scoped lang="stylus">
    .legenda-destacada
        font-size 14px
        color #664d03
        margin 8px 16px
        padding 5px 18px
        background-color #fff3cd !important
        border 1px solid #fff3cd !important
        border-radius 3px
        display flex
        flex-direction row
        align-items center

        p
            margin 0
            color #664d03 !important

        i
            color #664d03 !important

    .mensagem-aviso
        color white
</style>